import React from 'react'
import SubjectToCSSName from '../../../core/less/SubjectToCSSName'
import Heading from '../typography/heading/Heading'
import { UniLink } from '../unilink/index'
import replace from 'lodash/replace'
import './topicCard.css'

export default ({
  className,
  title,
  description,
  id,
  slug,
  breadcrumbTopics,
  query,
  subjectColorId,
  light
}) => {
  //todo: add highlighting to ElasticSearch
  let breadcrumbs = null
  let colorSubject = subjectColorId ? subjectColorId : id
  if (breadcrumbTopics.length) {
    breadcrumbs = `${breadcrumbTopics[0]}`
    if (breadcrumbTopics.length > 1) {
      breadcrumbs = `${breadcrumbs} > ${breadcrumbTopics[1]}`
    }
  }

  if (query) {
    title = replace(title, query, `<b>${query}</b>`)
    description = replace(description, query, `<b>${query}</b>`)
    breadcrumbs = replace(breadcrumbs, query, `<b>${query}</b>`)
  }
  const classNames = ['topiccard', className]
  if (light) {
    classNames.push('topiccard--light')
  }

  // Strip links text from links.
  description = replace(
    replace(description, /<a\b[^>]*>/gi, ''),
    /<\/a>/gi,
    ''
  )

  return (
    <UniLink className={classNames.join(' ')} to={slug}>
      <Heading
        color={`${SubjectToCSSName[colorSubject]}-nav`}
        dangerouslySetInnerHTML={{ __html: title }}
        fontWeight='medium'
        size='md'
      />
      <span
        className="topiccard__breadcrumbs"
        dangerouslySetInnerHTML={{ __html: breadcrumbs }}
      />
      <span
        className="topiccard__description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </UniLink>
  )
}

export const LoadingCard = ({
  className,
  light
}) => {
  const classNames = ['topiccard', 'topiccard--loading']
  if (className) {
    classNames.push(className)
  }
  if (light) {
    classNames.push('topiccard--light')
  }
  return (
    <div className={classNames.join(' ')}>
      <div className="topiccard__title topiccard__title--loading" />
      <div className="topiccard__description topiccard__description--loading" />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/core/components/topic-card/TopicCard.js